import Questions from './QuestionsContainer';

export default Questions;
